/**
 * Estimated 1-Rep Max (e1RM) calculators.
 * Delegates to the canonical Brzycki formula in lib/lifts/canonical.
 */

import { calculateE1RM as _calculateE1RM } from '@/lib/lifts/canonical';

/**
 * Calculate estimated 1RM using Brzycki formula (via canonical).
 * Returns 0 for invalid inputs. For 1 rep, returns weight directly.
 */
export function calculateE1RM(weight: number, reps: number): number {
  return _calculateE1RM(weight, reps);
}

/**
 * Format estimated 1RM as a display string.
 * Returns empty string if inputs are invalid or reps > 12.
 */
export function formatE1RM(weight: number, reps: number, unit: string): string {
  if (reps < 1 || reps > 12) return '';
  const e1rm = calculateE1RM(weight, reps);
  if (e1rm <= 0) return '';
  if (reps === 1) return ''; // No estimate needed for singles
  return `Est. 1RM: ${Math.round(e1rm * 10) / 10} ${unit}`;
}
